export default __webpack_public_path__ + "static/media/pasay.8efca193.jpg";